import { useRef, useState, useLayoutEffect } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "../data/content";

export const Process = () => {
  const ref = useRef(null);
  const trackRef = useRef(null);
  const [maxX, setMaxX] = useState(0);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });

  useLayoutEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const compute = () => setMaxX(Math.max(0, track.scrollWidth - track.clientWidth));
    compute();
    const ro = new ResizeObserver(compute);
    ro.observe(track);
    if (document.fonts?.ready) document.fonts.ready.then(compute);
    return () => ro.disconnect();
  }, []);

  // translate horizontally until the last card's edge meets the viewport edge
  const x = useTransform(scrollYProgress, [0, 1], [0, -maxX]);

  return (
    <section id="process" data-testid="process-section" ref={ref} className="relative h-[320vh]">
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <div className="orb bg-magenta" style={{ width: 480, height: 480, top: "0%", right: "0%", opacity: 0.12 }} />
        <div className="px-5 md:px-12">
          <div className="mb-10 flex items-baseline gap-4">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-electric">(Process)</span>
            <h2 className="font-display text-4xl font-extrabold uppercase tracking-tighter md:text-6xl">Concept → Commercial</h2>
          </div>
        </div>

        <motion.div ref={trackRef} style={{ x }} className="flex gap-6 px-5 md:px-12">
          {PROCESS.map((step, i) => (
            <div
              key={step.n}
              data-testid={`process-step-${step.n}`}
              className="group relative h-[52vh] w-[80vw] shrink-0 overflow-hidden rounded-2xl border border-white/10 p-8 transition-colors hover:border-electric/40 sm:w-[420px]"
            >
              <div className="absolute -right-6 -top-10 font-display text-[10rem] font-extrabold leading-none text-white/[0.04] transition-colors group-hover:text-electric/10">
                {step.n}
              </div>
              <div className="relative flex h-full flex-col justify-between">
                <span className="font-mono text-sm text-electric">{step.n} / 07</span>
                <div>
                  <h3 className="font-heading text-3xl font-bold text-cream md:text-4xl">{step.title}</h3>
                  <p className="mt-4 max-w-sm font-body text-base font-light leading-relaxed text-white/55">{step.desc}</p>
                </div>
              </div>
              {i < PROCESS.length - 1 && (
                <div className="absolute right-6 top-1/2 hidden -translate-y-1/2 text-white/20 sm:block">→</div>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
